import Vue from 'vue'
import Vuex from 'vuex'
import debug from 'debug'

import { findIndex } from './util'

const log = debug('v3:store')

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    navTags: [],
    isNavMenuOpen: true,
    currentTab:'',
    navMenuOpenIndex:'',
    tabPaneName:'',
    todoObject:{},
  },
  getters: {
    activeTag (state) {
      let tag = state.navTags.find((item) => {
        return item.active === true
      })
      return tag ? tag.index : ''
    },
    navTagIndexs (state) {
      return state.navTags.map((item) => {
        return item.index
      })
    },
    getCurrentTab (state) {
      return state.currentTab;
    },
    getNavMenuOpenIndex (state) {
      return state.navMenuOpenIndex;
    },
    getTodoObject (state) {
      return state.todoObject;
    },
    getMyTabPaneName (state) {
      return state.tabPaneName;
    }
  },
  mutations: {
    toggleMenuOpen (state, payload) {
      state.isNavMenuOpen = !state.isNavMenuOpen
    },
    changeCurrentTab (state, payload) {
      state.currentTab = payload
    },
    addNavMenuOpenIndex (state, payload) {
      state.navMenuOpenIndex = payload
    },
    updateTabPaneName (state, payload) {
      state.tabPaneName = payload
    },
    updateTodoObject (state, payload) {
      state.todoObject = payload
    },
    addNavTags (state, view) {
      let index = findIndex(state.navTags, 'index', view.meta.index)

      state.navTags.forEach((item) => {
        item.active = false
      })
      if (index === -1) {
        state.navTags.push({
          index: view.meta.index,
          title: view.meta.title,
          active: true
        })
      } else {
        state.navTags[index].active = true
      }
    },
    removeOneNavTag (state, payload) {
      let index = state.navTags.findIndex((item) => {
        return item.index === payload.index
      })
      if (index === -1) {
        return
      }
      state.navTags.splice(index, 1)
    }
  },
  actions: {
    addNavTags ({ state, commit }, view) {
      commit('addNavTags', view)
    },
    setNavMenuOpenIndex ({ state, commit }, view) {
      commit('addNavMenuOpenIndex', view)
    },
    setTabPaneName ({ state, commit }, view) {
      commit('updateTabPaneName', view)
    },
    SetCurrentTab ({ state, commit }, view) {
      commit('changeCurrentTab', view)
    },
    SetTodoObject ({ state, commit }, view) {
      commit('updateTodoObject', view)
    },
    removeOneNavTag ({ state, commit }, payload) {
      commit('removeOneNavTag', payload)
    }
  }
})
